import React from "react";
import "./Blog.css";
import Footer from "../components/Footer";
import imgPathways from "../assets/blog/pathways.png.webp";
import imgInvesting from "../assets/blog/investing-in-people.png.webp";
import imgWellbeing from "../assets/blog/team-wellbeing.png.webp";
import imgSport from "../assets/blog/sri-lankan-sport.png.webp";
import imgPartners from "../assets/blog/partners-ahead.png.webp";

const POSTS = [
  {
    id: "bixton-pathways",
    image: imgInvesting,
    // image: imgPathways,
    imageAlt:
      "Collage of Bixton Pathways interactive sessions—orientation, product training, and team discussions.",
    title: "Welcome to the Bixton Family: The Bixton Pathways Programme",
    paragraphs: ["Every member goes through a Human Talent Optimsation Program  namely the “Bixton Pathways” prior to comencing his careers at Bixton. They are taken through an interactive program to educate and make them aware  of the Bixton culture. Before kicking off  we educate and enlighten each member on their: roles, responsibilities, obligations etc so then they are well aware of what is expected of them by Bixton. It is our commitment that each new member continously learns and develops themselves as their move up in their career with us. These interactive sessions put them and ease and helps them better to understand the aspirations of the organisation so that they help contributing from the inception. "],
  },
  {
    id: "growing-together",
    // image: imgInvesting,
    image: imgSport,
    imageAlt:
      "Collage of training and workshops—seminars and team development under the Bixton banner.",
    title: "Growing Together: How Bixton Invests in Its People",
    paragraphs: [
      "Every member of the Bixton Team is encouraged to engage in furthering their professional education and knowledge in their selected field to realise their personal life goals. All members are given the opportunity to engage in projects and chair meetings on a rotational basis to develop their talent and groom them to take higher responsibilities. We want each of our members to learn and develop themselves in all aspects of work and their personal life.",
      "We sponsor professional courses to develop the talent of our people at external forums and professional development programmes. It is our objective for each and every one of our members to excel in their own work areas with world-class training.",
      "An annual assessment is in place to assess every member and reward and develop them.",
    ],
  },
  {
    id: "team-wellbeing",
    // image: imgWellbeing,
    image: imgPathways,
    imageAlt:
      "Collage from Bixton Family Day and team outings—families and colleagues together.",
    title: "Beyond the Workplace: Bixton's Commitment to Team Wellbeing",
    paragraphs: [
      "Every Bixton team member’s children receive their full set of school books from the company—we believe that education is the key to their success. Every member’s child, irrespective of how long they have been with the organisation, benefits from this initiative.",
      "Apart from this, families of team members are hosted for weekend stays at luxurious hotels across the country. This gives our members’ spouses and children an opportunity to interact with colleagues and their families and understand one another.",
      "Each member is taken care of at times of distress with outright grants and other facilities.",
    ],
  },
  {
    id: "sri-lankan-sport",
    // image: imgSport,
    image: imgPartners,
    imageAlt:
      "Collage of Bixton co-sponsorship with Royal College Rugby and Zahira College football events.",
    title: "Championing Local Talent: Bixton's Commitment to Sri Lankan Sport",
    paragraphs: [
      "We at Bixton believe in fostering unity amongst communities and giving a lesson to our younger generation—the best way of demonstrating this is through sport, where young minds are conditioned and trained to take both victory and defeat in the same spirit.",
      "Bixton has been the proud co-sponsor of Royal Rugby and Colombo Zahira College Football since 2024. We strongly believe that sport builds stamina and courage to face challenges with confidence, and helps the younger generation contribute to the wellbeing of the country at large.",
    ],
  },
  {
    id: "partners-ahead",
    // image: imgPartners,
    image: imgWellbeing,
    imageAlt:
      "Partner technical session and Bixton Fellowship Lunch 2026 at Ramada Colombo.",
    title: "Lighting the Way: Keeping Our Partners Ahead of the Curve",
    paragraphs: [
      "As a growing company, we share the latest information with our stakeholders to continuously upgrade the skills of our partners. We share the latest industry insights and follow up with workshops and panel discussions with them.",
      "Many of our corporate customers, in both the public and private sectors, are afforded this opportunity with our internal faculty and external resources as required.",
    ],
  },
] as const;

const Blog: React.FC = () => {
  return (
    <div className="contact-us-container blog-page">
      <section className="blog-hero" aria-labelledby="blog-main-heading">
        <div className="blog-hero-inner">
          <h1 id="blog-main-heading">
            Insights from{" "}
            <span className="blog-brand">Bixton</span>
          </h1>
          <p className="blog-lead">
            Culture, people, wellbeing, community, and how we grow alongside our
            partners—stories from life at{" "}
            <span className="blog-brand">Bixton</span>.
          </p>
        </div>
      </section>

      <nav className="blog-toc-wrap" aria-label="On this page">
        <div className="blog-toc-inner">
          <ol className="blog-toc">
            {POSTS.map((post, index) => (
              <li key={post.id}>
                <a href={`#${post.id}`}>
                  {index + 1}. {post.title}
                </a>
              </li>
            ))}
          </ol>
        </div>
      </nav>

      <div className="blog-articles">
        <div className="blog-articles-inner">
          {POSTS.map((post) => (
            <article
              key={post.id}
              id={post.id}
              className="blog-article"
              aria-labelledby={`${post.id}-title`}
            >
              <h2
                id={`${post.id}-title`}
                className="blog-article-title"
              >
                {post.title}
              </h2>
              <figure className="blog-article-figure">
                <img
                  src={post.image}
                  alt={post.imageAlt}
                  loading="lazy"
                  decoding="async"
                />
              </figure>
              <div className="blog-article-prose">
                {post.paragraphs.map((p, i) => (
                  <p key={`${post.id}-${i}`} className="blog-article-body">
                    {p}
                  </p>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>

      <section style={{ marginTop: "80px" }}>
        <Footer />
      </section>
    </div>
  );
};

export default Blog;
